import styles from './InfoPage.module.css';
import React, {useEffect, useState} from "react";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import infoJson from "./Infos.json";
import FloatingInput from "@/commons/components/fields/floatingInput/FloatingInput";
import CustomSelect from "@/commons/components/fields/customSelect/CustomSelect";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton"; // Importa il JSON direttamente

// Definizione del tipo per il JSON
interface Info {
    type: string;
    name: string;
    inputName?: string;
    apiRequest?: string;
}

type InfoOption = {
    key: string;
    info: Info;
};

type InfoJson = {
    [key: string]: Info;
};

const typedInfoJson: InfoJson = infoJson; // Tipizzazione corretta

const InfoPage = () => {
    let [option, setOption] = useState<string | undefined>(undefined);
    let [inputValue, setInputValue] = useState<string>("");
    let [isSelectable, setIsSelectable] = useState<boolean>(false);
    let [inputPlaceholder, setInputPlaceholder] = useState<string>("Seleziona un Opzione");
    let [apiUrl, setApiUrl] = useState<string | undefined>(undefined);
    let [options, setOptions] = useState<InfoOption[]>([]);
    let [apiResult, setApiResult] = useState<any>(null); // Per visualizzare il risultato

    useEffect(() => {
        loadSelector();
    }, []);

    function loadSelector() {
        // Estrai direttamente le opzioni dall'importazione JSON
        const options: InfoOption[] = Object.keys(typedInfoJson).map(key => ({
            key,
            info: typedInfoJson[key]
        }));
        setOptions(options);
    }

    function loadSelection(value: string) {
        const selectedOption = options.find(o => o.key === value);
        if (selectedOption) {
            setOption(selectedOption.info.name);
            if (selectedOption.info.type === "selectable") {
                setIsSelectable(true);
                setInputPlaceholder(selectedOption.info.inputName || "");
                setApiUrl(selectedOption.info.apiRequest);
            } else {
                setIsSelectable(false);
                setInputPlaceholder("Seleziona un Opzione");
                setApiUrl(undefined);
            }
        }
    }

    async function sendRequest() {
        setApiResult("");
        if (apiUrl && inputValue) {
            const url = apiUrl.replace("{var}", inputValue);

            try {
                const response = await fetch(url, {
                    method: 'GET'
                });

                if (response.status === 204) {
                    setApiResult(response.body);
                    return;
                }

                // Controlla se la richiesta ha successo
                if (!response.ok) {
                    throw new Error(`Errore nella richiesta: ${response.status}`);
                }

                // Leggi il risultato come JSON
                const result = await response.json();
                setApiResult(result); // Salva il risultato per visualizzarlo

            } catch (error: any) {
                console.error("Errore nella richiesta API", error);
                alert(`Errore durante la richiesta: ${error.message}`);
            }
        }
    }

    return (
        <>
            <div className={"page__body"}>
                <Header/>
                <div className={"page__content"}>
                    <div className={styles.infoForm}>
                        <h2>Informazioni degli Utenti</h2>
                        <div className={styles.break}/>
                        <div className={styles.rowElement}>
                            <CustomSelect
                                label="Seleziona un Opzione"
                                onChange={loadSelection}
                                options={options.map(option => ({
                                    label: option.info.type === "selector"
                                        ? `]--- ${option.info.name} ---[`
                                        : option.info.name,
                                    value: option.key,
                                    disabled: option.info.type === "selector"
                                }))}
                            />
                            <FloatingInput type={"text"}
                                           id={"InfoText"}
                                           disabled={!isSelectable}
                                           value={inputValue}
                                           onChange={(e) => setInputValue(e.target.value)}
                                           label={inputPlaceholder}/>
                        </div>
                        <div className={styles.break}/>
                        <CustomButton onClick={sendRequest} id={"InfoButton"} disabled={!isSelectable || !inputValue}>Invia
                            richiesta
                        </CustomButton>
                        <div className={styles.break}/>
                        {/* Visualizza il risultato */}
                        {apiResult && (
                            <>
                                <h3>Risultato:</h3>
                                <div className={styles.break}/>
                                <div className={styles.result}>
                                    <pre>{JSON.stringify(apiResult, null, 2)}</pre>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default InfoPage;
